import React from "react";
import {
  NavBarContainer,
  NavBarTitle,
  NavBarMenu,
  NavBarBody,
  NavBarLink,
  Wrapper,
  ColorText,
} from "./NavBarComponents";
import { FaTimes } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";

const Navbar = ({ show, setShow, activeColor, NavData, activeClass }) => {
  return (
    <Wrapper id="navbar">
      <NavBarContainer show={show ? 1 : undefined} fluid="xl">
        <NavBarTitle
          to="home"
          spy={true}
          smooth={true}
          offset={-70}
          duration={1000}
        >
          Sathish <ColorText color={activeColor}>K</ColorText>
        </NavBarTitle>
        <NavBarMenu show={show ? 1 : undefined} onClick={setShow}>
          {!show ? (
            <FiMenu style={{ fontSize: 25 }} />
          ) : (
            <FaTimes style={{ fontSize: 25 }} />
          )}
        </NavBarMenu>
        <NavBarBody>
          {NavData.map(({ link, text, active, id }) => {
            return (
              <NavBarLink
                spy={true}
                smooth={true}
                offset={-70}
                duration={800}
                key={id}
                to={link}
                active={active ? 1 : undefined}
                onClick={activeClass.bind(this, link)}
                color={activeColor}
                className={id === NavData.length && "last"}
              >
                {text}
              </NavBarLink>
            );
          })}
        </NavBarBody>
      </NavBarContainer>
    </Wrapper>
  );
};

export default Navbar;
